export default __webpack_public_path__ + "static/media/dex.a67dec81.svg";